import { FunctionComponent } from "react";
import { Container } from "../../../../components/formulario/styled";
import HeaderComponentsBatismoMembros from "./header";
import TabelaMembrosBatismo from "./tabela";

interface ContainerBatismoMembrosProps {

}

const ContainerBatismoMembros: FunctionComponent<ContainerBatismoMembrosProps> = () => {
  return (<>
    <Container>
      <HeaderComponentsBatismoMembros/>
      <TabelaMembrosBatismo />
    </Container>
  </>);
}

export default ContainerBatismoMembros;
